/**
 * Zustand store — delegates notifications to the Backbone notifications controller
 * passed in from the builder, so the React settings page uses the same notification
 * system as the rest of the app.
 */
import { create } from 'zustand';
export const useSettingsStore = create((set, get) => ({
    notifications: null,
    setNotifications: (n) => set({ notifications: n }),
    notify: (title, message, type = 'success') => {
        const n = get().notifications;
        if (!n) {
            return;
        }
        if (type === 'error') {
            n.error(message, title);
        }
        else {
            n.flash(message, title);
        }
    },
}));
